import { Table } from 'semantic-ui-react';
import { Children, isValidElement } from 'react';

const TableFpAlpha = ({ headers=[], data=[], positionHeaders = "start", children }) => {
    // Preprocesar los children para tenerlos como { valueKey: ReactElement }
    const customCells = {};
    Children.forEach(children, (child) => {
        if (isValidElement(child) && child.props.slot) {
            customCells[child.props.slot] = child;
        }
    });

    const getValueByPoints = (item, auxKey) => {
        const keys = auxKey?.split(".") || [];
        let auxItem = JSON.parse(JSON.stringify(item))
        for(const key of keys){
            auxItem = auxItem[key]
        }
        if(auxItem && typeof auxItem === "object"){
            return JSON.stringify(auxItem)
        }
        return auxItem
    }

    return (
        <Table celled>
            <Table.Header>
                <Table.Row>
                    {headers.map((header, index) => (
                        <Table.HeaderCell key={index} textAlign={positionHeaders}>
                            {header.title}
                        </Table.HeaderCell>
                    ))}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {data.map((item, rowIndex) => (
                    <Table.Row key={rowIndex}>
                        {headers.map((header, colIndex) => {
                            const cellKey = header.value;
                            const customCell = customCells[cellKey];
                            let valueToShow = getValueByPoints(item, cellKey);
                            if(!valueToShow && valueToShow !== 0){
                                valueToShow = header.defaultValue
                            }
                            if (customCell && typeof customCell.props.render === 'function') {
                                valueToShow = customCell.props.render({ data: item });
                            }

                            return (
                                <Table.Cell key={colIndex} textAlign={header.align || "start"}>
                                    {valueToShow}
                                </Table.Cell>
                            );
                        })}
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export default TableFpAlpha;
